import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  class: "gai-top"
};
import { RefreshIcon, ChevronRightDoubleIcon } from 'tdesign-icons-vue-next';
export default {
  __name: 'GaiTop',
  props: {
    title: {
      type: String,
      default: '批阅更多习练'
    }
  },
  emits: ['refresh', 'more'],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    var props = __props;
    var emit = __emit;
    return function (_ctx, _cache) {
      var _component_t_button = _resolveComponent("t-button");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_t_button, {
        variant: "text",
        onClick: _cache[0] || (_cache[0] = function ($event) {
          return emit('refresh');
        })
      }, {
        suffix: _withCtx(function () {
          return [_createVNode(_unref(RefreshIcon))];
        }),
        default: _withCtx(function () {
          return [_cache[2] || (_cache[2] = _createTextVNode(" 刷新 ", -1))];
        }),
        _: 1
      }), _createVNode(_component_t_button, {
        variant: "text",
        onClick: _cache[1] || (_cache[1] = function ($event) {
          return emit('more');
        })
      }, {
        suffix: _withCtx(function () {
          return [_createVNode(_unref(ChevronRightDoubleIcon))];
        }),
        default: _withCtx(function () {
          return [_createTextVNode(_toDisplayString(__props.title) + " ", 1)];
        }),
        _: 1
      })]);
    };
  }
};